import { StyleSheet, View, Modal, Image, Pressable } from "react-native";
import React from "react";
import color from "@constants/color";
// import Button from "@components/Button";
import Text from "@components/CustomText";
import t from "@constants/localization";
import { fontFamily } from "@utils/styles";

const PATH = "screens/LoggedInDevices";

const Button = ({
  btnText,
  buttonColor,
  borderColor,
  textColor,
  buttonStyle,
  onPress,
  testID,
}) => (
  <Pressable
    testID={testID}
    onPress={onPress}
    style={{
      ...buttonStyle,
      backgroundColor: buttonColor,
      borderColor,
      padding: 9,
    }}
  >
    <Text
      style={{
        color: textColor,
        textAlign: "center",
        fontFamily: fontFamily.bold,
      }}
    >
      {btnText}
    </Text>
  </Pressable>
);

const LogoutConfirmationModal = ({
  closeModal = () => {},
  showModal = false,
  onLogout = () => {},
  onCancel = () => {},
}) => {
  return (
    <Modal
      statusBarTranslucent
      navigationBarTranslucent
      transparent
      visible={showModal}
      onRequestClose={closeModal}
      animationType="fade"
    >
      <View style={styles.container}>
        <View style={styles.infoContainer}>
          <View style={styles.cardContainer}>
            <Image
              source={{
                uri: "https://public-cdn.citymall.live/cm-admin-storage-public/cl_app_icon%2F1686052854453-colouredLogoutIcon.png",
              }}
              resizeMode="contain"
              style={styles.logoutIcon}
            />
            <Text newfont={true} variant="title_18" style={styles.title}>
              {t(`${PATH}/modalTitle`)}
            </Text>
            <Text variant="caption_2" style={styles.description}>
              {t(`${PATH}/modalDescription`)}
            </Text>
          </View>
          <View style={styles.buttonContainer}>
            <Button
              testID={`${PATH}/cancelButton`}
              btnText={t(`${PATH}/cancelButton`)}
              buttonColor="white"
              borderColor={color.blank_grey}
              textColor="black"
              buttonStyle={styles.cancelButton}
              onPress={onCancel}
            />
            <Button
              testID={`${PATH}/logoutButton`}
              btnText={t(`${PATH}/logoutButton`)}
              buttonStyle={styles.logoutButton}
              onPress={onLogout}
              buttonColor={color.primary}
              textColor="white"
            />
          </View>
        </View>
      </View>
    </Modal>
  );
};

export default LogoutConfirmationModal;

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "rgba(0,0, 0, .6)",
    justifyContent: "center",
    alignItems: "center",
  },
  infoContainer: {
    backgroundColor: "#fff",
    width: "95%",
    borderRadius: 20,
    // alignItems: "center",
    marginHorizontal: 15,
    // alignSelf: "center",
  },
  cardContainer: {
    backgroundColor: "rgba(0, 171, 89, 0.05)",
    margin: 4,
    borderRadius: 16,
    paddingHorizontal: 21,
    paddingVertical: 16,
    alignItems: "center",
    justifyContent: "center",
    borderColor: "rgba(0, 171, 89, 0.3)",
    borderWidth: 1,
  },
  title: {
    textAlign: "center",
    marginTop: 8,
    color: color.mediumBlack,
  },
  description: {
    color: color.lightBlack,
    textAlign: "center",
    marginTop: 8,
  },
  buttonContainer: {
    flexDirection: "row",
    padding: 12,
  },
  cancelButton: {
    marginRight: 4,
    borderRadius: 10,
    borderWidth: 1,
    flex: 1,
  },
  logoutButton: {
    marginLeft: 4,
    borderRadius: 10,
    flex: 1,
  },
  logoutIcon: {
    width: 88,
    height: 88,
  },
});
